import { publicAsset } from './publicAsset';

export const CAT = {
  CAT_FACE_FRONT_SMILE: publicAsset('/landing-hero-cat.jpg'),
  CAT_FULL_FRONT: publicAsset('/landing-banner-cat.png'),
  CAT_FULL_CALL_CENTER: publicAsset('/cat-full-call-center.png'),
  CAT_FULL_BANNER_MOBILE: publicAsset('/cat-full-banner-mobile.png'),
  CAT_FULL_BANNER: publicAsset('/cat-full-banner.png'),
  CAT_BANNER_LANDING_MOBILE: publicAsset('/cat-landing-banner-mobile.png'),
  CAT_BANNER_LANDING: publicAsset('/cat-landing-banner.png'),
  CAT_BANNER_COVERAGES_MOBILE: publicAsset('/cat-banner-coverages-mobile.png'),
  CAT_BANNER_COVERAGES: publicAsset('/cat-banner-coverages.png'),
  CAT_HIRING_FLOATING_BOX_IMAGE: publicAsset('/icon-cat-float-box.png'),
  CAT_SUCCESS_YELLOW_CIRCLE: publicAsset('/cat_success.png'),
  CAT_SUCCESS_YELLOW_CIRCLE_BIG: publicAsset('/cat_success_big.png'),
  CAT_THINKING: publicAsset('/cat-thinking.png'),
  THINKING_TRANSPARENT: publicAsset('/cat-thinking-transparent.png'),
  CAT_OPEN_ARMS: publicAsset('/cat_open_arms.png'),
  CAT_POINTING: publicAsset('/cat_pointing.png'),
  CAT_CIRCLE: publicAsset('/cat-circle.png'),
  CAT_ENERGY_ROUND: publicAsset('/icon-cat-energy-round.png'),
  CAT_THINKING_ROUND: publicAsset('/icon-cat-thinking-round.png'),
  CAT_CYBERDAY: publicAsset('/cat-cyberday.png'),
  CAT_POINTING_BENEFITS: publicAsset('/cat-pointing.png'),
  CAT_WELCOME_BENETITS: publicAsset('/cat-welcome-round.png'),
  CAT_POINTING_EXCLUSIVE_BENETIS: publicAsset('/icon-cat-pointing.png'),
  CAT_POINTING_PREEXISTING: publicAsset('/icon-cat-pointing-circle.png'),
  CAT_SIDEWAYS: publicAsset('/cat_looking_sideways.png'),
  CAT_DOCTOR: publicAsset('/cat-doctor.png'),
  CAT_GREETING_CIRCLE: publicAsset('/cat_greeting_circle.png'),
  CAT_GREETING_CIRCLE_VARIABLE: publicAsset('/cat_greeting_circle_variable.png'),
  CAT_FACE: publicAsset('/cat_face.png'),
  CAT_THINKING_ROUND_YELLOW: publicAsset('/cat-thinking-round-yellow.png'),
  CAT_JACKET_CIRCLE: publicAsset('/cat_jacket_circle.png'),
};

export const CI = {
  old: publicAsset('/old_CI.png'),
  new: publicAsset('/new_CI.png'),
};

export const CAT_V2 = {
  CAT_JACKET: publicAsset('/cat_jacket.png'),
};

export const CAT_LANDING_BANNER = {
  src: publicAsset('/landing-banner-cat.png'),
  webP: publicAsset('/landing-banner-cat.webp'),
};

export const LOGO = {
  WHITE: publicAsset('/logo-white.svg'),
  COLOR: publicAsset('/logo-color.svg'),
  TOFFEE: publicAsset('/logo-toffee.svg'),
};
export const RRSS = {
  FACEBOOK: publicAsset('/icon-footer-facebook.svg'),
  TWITTER: publicAsset('/icon-footer-twitter.svg'),
  INSTAGRAM: publicAsset('/icon-footer-instagram.svg'),
  YOUTUBE: publicAsset('/icon-footer-youtube.svg'),
  X: publicAsset('/icon-footer-x.svg'),
};
export const ICON_SHIELD = publicAsset('/landing-hero-cat-shield.svg');
export const ICON_STAR = publicAsset('/landing-hero-star.svg');
export const COVID = publicAsset('/icon-toaster-covid.svg');
export const INSURANCE_HEALTH = publicAsset('/landing_insurance_health.svg');
export const INSURANCE_LIFE = publicAsset('/landing_insurance_life.svg');
export const INSURANCE_DENTAL = publicAsset('/landing_insurance_dental.svg');
export const INSURANCE_CATASTROPHIC = publicAsset('/landing_insurance_catastrophic.svg');
export const BENEFIT_MASK = publicAsset('/benefit-imgmask.jpg');
export const BENEFIT_NUTRI = publicAsset('/benefit-imgnutri.jpg');
export const BENEFIT_KINE = publicAsset('/benefit-imgkine.jpg');
export const BENEFIT_BV_MORE = publicAsset('/icon-benefits-bv.svg');
export const BENEFITS_CARD_PYME = {
  src: publicAsset('/benefits-card-pyme.jpg'),
  webP: publicAsset('/benefits-card-pyme.webp'),
};
export const BENEFITS_CARD_DIGITAL = publicAsset('/benefits-card-digital.png');
export const BENEFITS_CARD_TELEHEALTH = publicAsset('/benefits-telehealth.png');

export const TELEMEDICINE_CARD = publicAsset('/telemedicine-card.png');

export const NUBOX_CARD = publicAsset('/benefits-nubox.png');

export const BENEFITS_CARD_AGREEMENT = publicAsset('/benefits-card-agreement.jpg');

export const BENEFITS_CARD_CIRCLE = publicAsset('/benefits-card-circle.jpg');

export const BENEFITS_CARD_COVERAGE = publicAsset('/benefits-card-coverage.jpg');

export const BENEFITS_HEALTH_SCAN = {
  src: publicAsset('/benefit-imgscan.jpg'),
  webP: publicAsset('/benefit-imgscan.webp'),
};
export const BENEFITS_HEALTH_DOCTOR = {
  src: publicAsset('/benefit-imgdoctor.jpg'),
  webP: publicAsset('/benefit-imgdoctor.webp'),
};
export const BENEFITS_HEALTH_TEST = {
  src: publicAsset('/benefit-imgtest.jpg'),
  webP: publicAsset('/benefit-imgtest.webp'),
};
export const BENEFITS_HEALTH_EYE = {
  src: publicAsset('/benefit-imgeye.jpg'),
  webP: publicAsset('/benefit-imgeye.webp'),
};
export const BENEFITS_HEALTH_MEDICINE = {
  src: publicAsset('/benefit-imgmedicine.jpg'),
  webP: publicAsset('/benefit-imgmedicine.webp'),
};
export const BENEFITS_HEALTH_PILL = {
  src: publicAsset('/benefit-imgpill.jpg'),
  webP: publicAsset('/benefit-imgpill.webp'),
};
export const BENEFITS_LOGO_HOSPITAL_ONE = publicAsset('/logo-hospital-one.jpg');
export const BENEFITS_LOGO_HOSPITAL_TWO = publicAsset('/logo-hospital-two.jpg');
export const BENEFITS_LOGO_HOSPITAL_THREE = publicAsset('/logo-hospital-three.jpg');
export const BENEFITS_LOGO_HOSPITAL_FOUR = publicAsset('/logo-hospital-four.jpg');
export const BENEFITS_HOSPITAL_BRANDS = publicAsset('/benefits-hospital-brands.png');
export const BENEFITS_ICON_PILLS = publicAsset('/benefits-icon-pills.png');
export const BENEFITS_ICON_MEDICAL_CASE = publicAsset('/benefits-icon-medical-case.png');
export const BENEFITS_ICON_SNAKE = publicAsset('/benefits-icon-snake.png');
export const BENEFITS_ICON_TUBE = publicAsset('/benefits-icon-tube.png');
export const BENEFITS_PHARMACY_REFUND = publicAsset('/benefits_pharmacy_refund.png');
export const BENEFITS_PHARMACY = publicAsset('/benefits_pharmacy.png');
export const ICON_BLUE_DOCUMENT = publicAsset('/icon-blue-document.svg');
export const DEMO_ICON = publicAsset('/demo-icon.png');

export const BENEFITS_CIRCLE = {
  CUP: publicAsset('/circle_bice_cup.png'),
  HEART: publicAsset('/circle_bice_heart.png'),
  LAMP: publicAsset('/circle_bice_lamp.png'),
  PILLS: publicAsset('/circle_bice_pills.png'),
  TOOTH: publicAsset('/circle_bice_tooth.png'),
};

export const BENEFITS_BELIV = {
  LOGO: publicAsset('/beliv_logo.svg'),
};

export const BENEFITS_IMAGES = {
  TELEMEDICINE: publicAsset('/benefit-telemedicine.png'),
  DRUGSTORE: publicAsset('/benefit-drugstore.png'),
  REFUND: publicAsset('/benefit-refund.png'),
  HOSPITAL_COVERAGE: publicAsset('/benefit_hospital_coverage.png'),
  DIGITAL: publicAsset('/benefit_digital.png'),
  CIRCLE: publicAsset('/benefit_circle.png'),
};

export const BENEFITS_TABLE = {
  SHIELD: publicAsset('/shield-icon.png'),
  H_ICON: publicAsset('/h-icon.png'),
  GRAPH: publicAsset('/graph-icon.png'),
  CROSS: publicAsset('/cross-icon.png'),
  HEART: publicAsset('/heart-icon.png'),
};

export const HERO_ICON = {
  HEART: publicAsset('/hero-icon-heart.png'),
  SHIELD: publicAsset('/hero-icon-shield.png'),
  FOLDERS: publicAsset('/hero-folder.png'),
  NURSE: publicAsset('/hero-icon-nurse.png'),
};

export const ESTIMATE_CUSTOMIZE = publicAsset('/icon-estimate-customize.svg');
export const ESTIMATE_CONTACT = publicAsset('/icon-estimate-contact.svg');
export const ESTIMATE_HIRE = publicAsset('/icon-estimate-hire.svg');
export const WAVE_BANNER_LANDING = publicAsset('/landing-banner-wave.svg');
export const ICON_WORKING = publicAsset('/icon-working.svg');
export const ICON_HIRE_MODAL = publicAsset('/icon-hire-landing-modal.png');
export const MODAL_INFORMATION_FORM = publicAsset('/modal-information-form.png');
export const ICON_MODAL_CHECK = publicAsset('/form_modal_check.png');
export const LOGO_BICE = publicAsset('/logo-bice.png');

export const HELP_DESK_ICONS = (icon: string) => publicAsset(`/help-desk-icon-${icon}.svg`);
export const ICON_EMAIL = publicAsset('/email.svg');
export const ICON_PHONE = publicAsset('/icon-phone.svg');
export const FEEDBACK_THANKS_MODAL = publicAsset('/duo-hearts.svg');
export const KEEP_IMPROVING_MODAL = publicAsset('/keep-improving.svg');
export const INSURANCE_LIFE_PLUS_CIRCLE = publicAsset('/icon-coverages-card-heart.png');
export const INSURANCE_DENTAL_CIRCLE = publicAsset('/icon-coverages-card-tooth.png');
export const INSURANCE_CATASTROPHIC_CIRCLE = publicAsset('/icon-coverages-card-ambulance.png');
export const ICON_CHARGES: any = {
  iconWithCharges: publicAsset('/icon-with-charges.svg'),
  iconWithoutCharges: publicAsset('/icon-without-charges.svg'),
  iconWithMoreCharges: publicAsset('/icon-with-more-charges.svg'),
};
export const ICON_ARROW_CAT_DIALOGUE = publicAsset('/icon-arrow-cat-dialogue.svg');
export const IMG_GREETING_CAT_DIALOGUE = publicAsset('/icon-personal-info-cat.png');
export const IMG_EMAIL_CAT_DIALOGUE = publicAsset('/icon-email-cat.png');
export const IMG_WORKERS_CAT_DIALOGUE = publicAsset('/icon-workers-cat.png');
export const IMG_PLANS_CAT_DIALOGUE = publicAsset('/icon-plans-cat.png');
export const ICON_WORKERS_DIALOGUE = publicAsset('/icon-workers-thinking-cat.svg');
export const IMG_COVERAGES_CAT_DIALOGUE = publicAsset('/icon-coverages-cat.png');
export const IMG_FORM_CAT_DIALOGUE = publicAsset('/icon-form-cat.png');
export const IMG_SUCCESS_CHECK = publicAsset('/icon-success-check-cat.svg');
export const IMG_SUMMARY_STEP_CAT = publicAsset('/summary-step-cat.jpg');
export const IMG_CAT_BOX = publicAsset('/icon-cat-box.png');
export const ICON_PROMO = publicAsset('/icon_promo.svg');

export const ICON_UP_ARROW_CIRCLE_GREEN = publicAsset('/up_icon_green_circle.svg');
export const ICON_ARROW_FORWARD = publicAsset('/arrowforward.png');
export const ICON_CLOSE_CIRCLE_RED = publicAsset('/close_icon_red_circle.svg');
export const IMG_ERROR_CIRCLE_RED = publicAsset('/form_modal_fail.svg');
export const IMG_META_SOCIAL_CAT = publicAsset('/meta_social_cat.png');

export const IMG_COFFEE = publicAsset('/coffe.svg');

export const ICON_USER = publicAsset('/icon-user.svg');

export const IMG_LINK = publicAsset('/link.svg');

export const SEARCH = publicAsset('/search.svg');

export const ICON_HIRING_ADMIN_PROFILE = publicAsset('/icon-hiring-admin-profile.png');
export const IMG_COVERAGE_AMBULANCE = publicAsset('/img_coverage_ambulance.png');
export const IMG_COVERAGE_DENTAL = publicAsset('/img_coverage_dental.png');
export const IMG_COVERAGE_HEALTH = publicAsset('/img_coverage_health.png');
export const IMG_COVERAGE_HEART = publicAsset('/img_coverage_heart.png');
export const IMG_COVERAGE_PAWER = publicAsset('/pawer-cat-and-dog.png');
export const IMG_COVERAGE_DECEASE = publicAsset('/img_coverage_decease.png');

export const IMG_TARGET = {
  DESKTOP: publicAsset('/target-image.png'),
  MOBILE: publicAsset('/target-image-mobile.png'),
};

export const ICON_CHECK = publicAsset('/icon-check.svg');
export const ICON_CLOSE = publicAsset('/icon-close.svg');
export const ICON_CHECK_CIRCLE = publicAsset('/form_modal_check.svg');

export const IMG_PRICES_AND_PLANS = {
  AMBULANCE: publicAsset('/prices-and-plans-ambulance.png'),
  DENTAL: publicAsset('/prices-and-plans-dental.png'),
};

export const ICON_DOWNLOAD = publicAsset('/download-document-step.svg');

export const CYBER_IMAGES = {
  LOGO: publicAsset('/promo_banner/cyber-logo.png'),
  CAT_POINTER: publicAsset('/promo_banner/cat-pointer.png'),
  CAT_POINTER_CIRCLE: publicAsset('/promo_banner/cat-pointer-circle.png'),
  GRADIENT_ARC: publicAsset('/promo_banner/gradient-arc.png'),
  REVIEW: publicAsset('/promo_banner/cyber-review.png'),
};

export const PYME_DATA_ICON = publicAsset('/pyme-data-icon.png');
export const PYME_FORM_ICON = publicAsset('/pyme-form-icon.png');
export const PYME_PROGRESS_ICON = publicAsset('/pyme-progress-icon.png');
export const SUMMARY_INFO_ICON = publicAsset('/icon-alert-info-summary.svg');
export const WARNING_CIRCLE_ICON = publicAsset('/warning-icon-circle.png');
export const WARNING_ICON_VARIANT = publicAsset('/warning-icon_variant.png');
export const WARNING_ICON = publicAsset('/warning-icon.png');
export const EMPTY_COMPANY_DATA_ICON = publicAsset('/empty-company-data-icon.png');
export const TODO_LIST_ICON = publicAsset('/todo-list.png');
export const TODO_LIST_ICON_V2 = publicAsset('/todo_list_v2.png');
export const TODO_LIST_ICON_GREY = publicAsset('/todo-list-rounded-grey-bg.png');

export const BENEFITS_LOGOS = [
  { img: publicAsset('/logo-imed.png'), alt: 'imed' },
  { img: publicAsset('/logo-cruzverde.png'), alt: 'cruz verde' },
  { img: publicAsset('/logo-placevendome.png'), alt: 'place vendome' },
  { img: publicAsset('/logo-gmo.png'), alt: 'gmo' },
  { img: publicAsset('/logo-chilling.png'), alt: 'chilling' },
  { img: publicAsset('/logo-rotterykrauss.png'), alt: 'rotter y krauss' },
];

export const HIRING_COMPANY_ICONS = {
  COMPANY_DATA_ICON: publicAsset('/company-data-icon.png'),
  ADMIN_ICON: publicAsset('/who-admin-icon.png'),
};

export const SVG_LIST = {
  incorporationPreModal: publicAsset('/incorporation-pre-modal.svg'),
  iconDocumentSummary: publicAsset('/icon-document.svg'),
  iconWithCharges: publicAsset('/icon-with-charges.svg'),
  iconSummaryInfo: publicAsset('/icon-summary-info.svg'),
  formModalCheck: publicAsset('/form_modal_check.svg'),
  formModalFail: publicAsset('/form_modal_fail.svg'),
  iconWorking: publicAsset('/icon-working.svg'),
  iconHotPopularplan: publicAsset('/icon-hot-popular-plan.svg'),
  imgModalIndividualInsurance: publicAsset('/icon-workers-warning.png'),
  riskyActivitiesInfoModal: publicAsset('/dumbbell-gray.png'),
  familyGroupInfoModal: publicAsset('/family-group-info-modal-step.svg'),
  beneficiariesInfoModal: publicAsset('/beneficiaries-info-modal-step.svg'),
  downloadDocument: publicAsset('/download-document-step.svg'),
  incorporationSent: publicAsset('/incorporation-sent.svg'),
  incorporationPending: publicAsset('/incorporation-pending.svg'),
  iconCoffe: publicAsset('/coffe.svg'),
  sendEmail: publicAsset('/email.svg'),
  iconSuccessCheckCat: publicAsset('/icon-success-check-cat.svg'),
  iconModalHoldingCat: publicAsset('/cat-thinking.png'),
  iconTaskSuccess: publicAsset('/task-success.svg'),
  iconCalendar: publicAsset('/icon-calendar.svg'),
  variantFolder: publicAsset('/icon-folder-circle-variant.png'),
};

export const REQUERIMENTS_TO_CONTRACT = {
  callcenter: publicAsset('/icon-callcenter-circle.png'),
  folder: publicAsset('/icon-folder-circle.png'),
  heart: publicAsset('/icon-heart-circle.png'),
  like: publicAsset('/icon-like-circle.png'),
  notebook: publicAsset('/icon-notebook-circle.png'),
  wifi: publicAsset('/icon-wifi-circle.png'),
};

export const TESTIMONIES = {
  mic: publicAsset('/microphone_icon.png'),
  roda: publicAsset('/roda_logo.png'),
};

export const CAT_SUCCESS_VARIABLE = publicAsset('/cat_success_variable.png');
export const NOTEBOOK = publicAsset('/notebook.png');
export const WHITE_HEADPHONES_ANGLE = publicAsset('/white_headphones_angle.png');
export const WRITING_MESSAGE = publicAsset('/writing_message.png');

export const MAIL_ENVELOPE = publicAsset('/icon-mail-envelope.png');
export const MAIL_ENVELOPE_BLUE = publicAsset('/icon-mail-envelope-blue.png');
export const CONTENT_COPY = publicAsset('/content_copy.svg');
export const CONTENT_COPY_BLUE = publicAsset('/content_copy_blue.svg');
export const LAMP_ROUNDER_PINK_BG = publicAsset('/lamp_rounded_pink_bg.png');
export const NOTES_BLUE_BACKGROUND = publicAsset('/notes.png');
export const SUCCESS_ICON_CHECK = publicAsset('/green_check.png');
export const ERROR_ICON_CROSS = publicAsset('/error_cross.png');
export const SUCCESS_CONTACT_ICON_CHECK = publicAsset('/green_check_contact.png');
export const ERROR_CONTACT_ICON = publicAsset('/error_contact.png');

export const BENEFIT = {
  ICON_HEARTH: publicAsset('/benefit-icon-hearth.png'),
  ICON_MEDICINE: publicAsset('/benefit-icon-medicine.png'),
  ICON_SNAKE: publicAsset('/benefit-icon-snake.png'),
  ICON_TENIS: publicAsset('/benefit-icon-tenis.png'),
};

export const ICON_INFO = publicAsset('/icon-info.svg');

export const ICON_MEDICAL_CASE = publicAsset('/icon_medical_case.png');

export const PROMO_CYBER = {
  cat_cyber_nav_1: publicAsset('/cat-cyber-nav-1.png'),
  cat_cyber_nav_2: publicAsset('/cat-cyber-nav-2.png'),
  cat_cyber_nav_3: publicAsset('/cat-cyber-nav-3.png'),
  cyber_safe: publicAsset('/cyber-safe.svg'),
  promo_banner: publicAsset('/promo_banner/cyber_safe.png'),
};

export const BICENTE_HIDING = publicAsset('/img/bicente-hiding.png');

export const BENEFITS_TABS = {
  BENEFITS_ELECTION_PIC: publicAsset('/benefits-election-pic.png'),
  BENEFITS_COVERAGE_PIC: publicAsset('/benefits-coverage-pic.png'),
  BENEFITS_WINDOW_PIC: publicAsset('/benefits-window-pic.png'),
};

export const BENEFITS_WELLNESS = {
  BENEFIT_IMG_YOGA: publicAsset('/benefit-img-yoga.png'),
  BENEFIT_IMG_HOME: publicAsset('/benefit-img-home.png'),
  BENEFIT_IMG_FREETIME: publicAsset('/benefit-img-freetime.png'),
  BENEFIT_IMG_DOG: publicAsset('/benefit-img-dog.png'),
};

export const GENDER_OPTIONS = {
  ICON_GIRL: publicAsset('/img/icon_girl.png'),
  ICON_BOY: publicAsset('/img/icon_boy.png'),
};

export const QUOTER_COVERAGES = {
  ICON_COVERAGES_TOOTH: publicAsset('/icon_coverages_tooth.png'),
  ICON_COVERAGES_CRUTCHES: publicAsset('/icon_coverages_crutches.png'),
  ICON_COVERAGES_MONITOR: publicAsset('/icon_coverages_monitor.png'),
};

export const GENERAL_TEXTS = {
  BENEFIT_CAT_ALERT: publicAsset('/benefit-cat-alert.png'),
  CARD_APPLE_APP_STORE: publicAsset('/card-apple-app-store.png'),
  CARD_GOOGLE_PLAY_STORE: publicAsset('/card-google-play-store.png'),
  GATO_YELLOW: publicAsset('/img/gato_yellow.png'),
  GATO: publicAsset('/img/gato.svg'),
  ICON_TOOTH: publicAsset('/icon-tooth.png'),
  ICON_AMBULANCE: publicAsset('/icon-ambulance.png'),
  ICON_CAT_FOOT: publicAsset('/icon-cat-foot.png'),
};

export const BADGE_ICON = (icon: string) => publicAsset(`/icon-${icon}.svg`);

/* FILES FROM S3, DON'T ADD publicAsset() */
export const PDFS = {
  PLANS: '/Coberturas_Seguro_Colectivo_Pyme.pdf',
  POLICY: '/Poliza_Seguro_Colectivo_Pyme.pdf',
  BROCHURE: '/Folleto_Mi_Pyme_Segura.pdf',
  CYBER: '/pdfs/bases/Bases_PYME_Campana_Cyber_Rev_2024.pdf',
  POST_CYBER: '/pdfs/bases/Bases_PYME_Extendimos_octubre_2023.pdf',
  CYBER_EXTEND: '/pdfs/bases/Bases_PYME_Extendimos_Cyber_Rev_2024.pdf',
  PROMO_NUBOX: '/pdfs/bases/Bases_Promo_Nubox.pdf',
  PROMO_CHIPAX: '/pdfs/bases/Bases_Promo_Chipax.pdf',
  PROMO_AON_CYBER: '/pdfs/bases/Bases_Promo_Aon_octubre_2023.pdf',
  TELEHEALTH: '/pdfs/telehealth.pdf',
  PHARMACY: '/pdfs/Red_Farmacias_abr2024.pdf',
  PREEXISTING: '/pdfs/condiciones_de_exclusiones.pdf',
  DECESO: '/Cobertura_Deceso.pdf',
};